module.exports = __webpack_public_path__ + "static/media/logo3.1ecb9e8d.png";